import { notify } from '@kyvg/vue3-notification';
export function notification({ group = 'base', type = 'error', title, text, duration = 6000 }) {
    return notify({
        group,
        type,
        // duration: -1,
        duration,
        title,
        text,
    });
};
